import { default as i18n } from 'i18next'
import detector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import { LANGUAGES } from './infra/constants/languages'
import translationEN from './locales/en.json'
import translationPT from './locales/pt.json'

const resources = {
  pt: {
    translation: translationPT
  },
  en: {
    translation: translationEN
  }
}

const normalizeLanguageSetting = () => {
  try {
    const storedLanguage = localStorage.getItem('I18N_LANGUAGE')

    if (!storedLanguage) {
      localStorage.setItem(
        'I18N_LANGUAGE',
        JSON.stringify({ abrev: LANGUAGES.EN.abrev, id: LANGUAGES.EN.languageId })
      )
      return { abrev: LANGUAGES.EN.abrev, id: LANGUAGES.EN.languageId }
    }

    let parsedLanguage
    try {
      parsedLanguage = JSON.parse(storedLanguage)
    } catch (e) {
      const defaultLanguage = {
        abrev: storedLanguage || LANGUAGES.EN.abrev,
        id: LANGUAGES.EN.languageId
      }
      localStorage.setItem('I18N_LANGUAGE', JSON.stringify(defaultLanguage))
      return defaultLanguage
    }

    if (
      !parsedLanguage ||
      typeof parsedLanguage !== 'object' ||
      !parsedLanguage.abrev
    ) {
      const defaultLanguage = {
        abrev:
          typeof parsedLanguage === 'string'
            ? parsedLanguage
            : LANGUAGES.EN.abrev,
        id: LANGUAGES.EN.languageId
      }
      localStorage.setItem('I18N_LANGUAGE', JSON.stringify(defaultLanguage))
      return defaultLanguage
    }

    return parsedLanguage
  } catch (error) {
    return { abrev: LANGUAGES.EN.abrev, id: LANGUAGES.EN.languageId }
  }
}

const currentLanguage = normalizeLanguageSetting()

i18n.languageId = currentLanguage.id

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    lng: currentLanguage.abrev,
    fallbackLng: LANGUAGES.EN.abrev,
    keySeparator: false,
    interpolation: {
      escapeValue: false
    }
  })

export default i18n
